import qs from '@scoir/query-string'
import { filter, find, get, map } from 'lodash'

import requiredActionMapping from 'routes/RequiredActions/actions'

import { idMapping as actionIdMapping } from './action-definitions'
import actions from './actions'

const createRequiredActionsFn = (interruptsList) => {
  return (user, profile, prospects) =>
    map(
      filter(interruptsList, (key) => actions[key](user, profile, prospects)),
      (key) => actionIdMapping[key],
    )
}

export const defaultRequiredActions = (user, profile, prospects) => {
  const interruptsList = [
    'HSE',
    'CHSE',
    'FERPA-R-DATE',
    'FERPA-PR-DATE',
    'FERPA-W-DATE',
    'PTN-HS',
    'OUTCOMES',
    'EARLY-DECISION-CONTRACT',
    'FEE-WAIVER',
  ]
  return createRequiredActionsFn(interruptsList)(user, profile, prospects)
}

export const reduxRequiredActions = (store) => {
  const user = store.user.record
  const profile = user?.Profile
  const prospects = store.prospects?.prospects
  return defaultRequiredActions(user, profile, prospects)
}

export const routeRequiredActions = (actions) =>
  `${import.meta.env.BASE_URL}/required-actions/intro?${qs.stringify({ actionList: actions, after: '/home' })}`
export const getRouteToRequiredActionForKey = (actionKey) => {
  const href = get(find(requiredActionMapping, { id: actionKey }), 'href')
  return `${import.meta.env.BASE_URL}/required-actions/${href}?${qs.stringify({
    actionList: [actionKey],
    after: '/home',
    activeIdx: 0,
  })}`
}
